import React, { Component } from 'react'

export default class WorksLuciDelTreno extends Component {
    render() {
        return (
            <div class="modal" id="workslucitreno" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-full" role="document">
                    <div class="modal-content">
                    <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
            </div>
                        <div class="modal-header">
                            <h5 class="modal-title">
                                <strong>&quot;Le luci del
        treno&quot; </strong>(romanzo): <em>Marsilio Editori, Venezia, 1992. </em> <br /><br />Inserito nel Programma Pilota 1992 di Invito alla lettura della Fondazione Bellonci. Finalista al Premio "Regium Giuli" 1992.
                                                                                                                                Vincitore del Premio "Sirmione-Catullo" 1992.
        </h5>
                          
                        </div>
                        <div class="modal-body p-4" id="result">
                            <div align="left">



                                <br /><br /><br />


                                <strong>ne hanno scritto:</strong> <br /><br />

                                Fulvio Panzeri, Avvenire, 23.2.92 <br />
                                Maria Vittoria Vittori, Wimbledon, giugno 92 <br />
                                Idolina Landolfi, Il Giornale, 6.9.92 <br />
                                Generoso Picone, Il Mattino di Napoli, 3.3.92 <br />
                                Alessandro Cogolo, Il Gazzettino di Venezia, 28.4.92 <br />
                                Donatello Bellomo, L'Arena di Verona, 20.3.92 <br />
                                Giuseppe Amoroso, La Gazzetta del sud, 15.5.92 <br />
                                Irma Guldan, Brescia Oggi, 8.7.92 <br />
                                Giampaolo Visetti, L'Adige, 17.3.92 <br />
                                Carlo Martinelli, L'Alto Adige, 2.4.92 <br />
                                Tino Copobianchi, Il Ticino di Pavia, 4.5.92 <br />
                                Angelo Ferracuti, La Gazzetta di Ancona, 20.5.92 <br />
                                Mario Gismondi, Puglia, 10.3.92 <br />
                                Marcello Petrozziello, La Nazione, 12.3.92 <br />
                                Antonello Capitanio, Il Tirreno, 10.3.92 <br />
                                Roberto Ferrucci, LA Nuova Venezia, 9.7.92 <br />
                                Elisabetta Marchetti, Corriere Umbria, 18.8.92 <br />
                                Sergio Damiani, La Cronaca di Verona <br />
                                Franca Eller, L'Alto Adige, 9.12.92 <br />
                                Alessandra Truzzi, Il Giornale di Vicenza, 7.5.92 <br />
                                Fulvio Panzeri, L'Esagono, 24.2.92 <br />
                                Cristina Nesi, Il Ponte, dicembre 92 <br />
                                Quinto Antonelli, QuestoTrentino, 20.3.92 <br />
                                Roberto Antolini, Archivio di Storia Contemporanea, 1.93 <br />
                                Luigi Serravalli, UCT, ottobre 92 <br />


                            </div>

                            <div align="left">
                                <strong>Selezione Stampa</strong>
                                <table border="0" align="center" cellspacing="7">
                                    <tr>
                                        <td align="center" width="100%">
                                            &quot;Arrivo Senza Partenza&quot; di Irma Guldan. (217k)
                                        </td>
                                        <td>
                                            <a href="rec\lucitreno-arrivo.zip"><img src="./img/rec/lucitreno-arrivo_small.jpg" alt="scarica in formato zip" width="260" height="209"></img></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="center" width="100%">
                                            9/1992 &quot;Lui, Lei e il Crepuscolo&quot; di Idolina Landolfi. (145k)
                                        </td>
                                        <td>
                                            <a href="rec/lucitreno-luilei.zip"> <img src="./img/rec/lucitreno-luilei_small.jpg" alt="scarica in formato zip" width="124" height="210"></img></a>
                                        </td>
                                    </tr>
                                    <tr>


                                        <td align="center" width="100%">Avvenire 23/2/1992 &quot;Per Tamburini
                                        Un Viaggio Scandito Dal vuoto&quot; di Fulvio Panzeri.
        (186k)</td><td><a href="rec\lucitreno-pertamburini.zip"><img src="./img/rec/lucitreno-pertamburini_small.jpg" alt="scarica in formato zip"
                                            width="111" height="241"></img></a>
                                        </td>

                                    </tr>
                                </table >
                            </div >

                        </div >
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">CHIUDI</button>
                        </div>
                    </div >
                </div >
            </div >


        )
    }
}
